module.exports = __webpack_public_path__ + "static/media/burger.2a3c3ddd.JPG";